// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._657c7a{display:flex;border-radius:.5rem;box-shadow:inset 0 0 0 2px var(--primary);margin-top:0 !important;margin-bottom:0 !important}._657c7a>*{box-shadow:none !important;background:none}._657c7a>label{flex:1}._657c7a>button{transform:scale(0.75)}._657c7a>button svg{transform:scale(2)}.a1b5a3{box-shadow:none;margin:-1em -1.25em !important;padding:.5em;border-radius:1rem}", ""]);
// Exports
exports.locals = {
	"compact": "_657c7a",
	"compact-popup": "a1b5a3 _657c7a",
	"compactPopup": "a1b5a3 _657c7a"
};
module.exports = exports;
